import React from "react";
import { myUtilities } from "../Utils";

const PayableSumGridItemMUX = ({data, msgKey, defaultMsg, className, additionalFields}) => {
  return (
    <div className={`payment-summ-item`}>
      <span>
        {myUtilities.accountSpecificLanguage(msgKey, defaultMsg)}:
      </span>
      <span className={`${className}`}>{data}</span>
      {additionalFields && additionalFields}
    </div>
  );
};

export default PayableSumGridItemMUX;
